module.exports = __webpack_public_path__ + "static/media/01d.e5b86975.svg";